import React from 'react';

function BreadcrumbNav({ items = [] }) {
  return (
    <nav className="breadcrumb-nav py-3 px-3 bg-light rounded shadow-sm" aria-label="Caminho de navegação">
      <ol className="breadcrumb mb-0">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className={`breadcrumb-item ${isLast ? 'active fw-semibold text-dark' : ''}`} aria-current={isLast ? 'page' : undefined}>
              {item.href && !isLast ? (
                <a href={item.href} className="text-decoration-none text-success fw-medium">
                  {item.icon && <i className={`${item.icon} me-1`}></i>}
                  {item.label}
                </a>
              ) : (
                <span className={isLast ? '' : 'text-muted'}>
                  {item.icon && <i className={`${item.icon} me-1`}></i>}
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>

      <style>{`
        .breadcrumb-nav {
          font-size: 0.95rem;
          background: #f8f9fa;
        }

        .breadcrumb a:hover {
          text-decoration: underline;
          color: #218838;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          content: "›";
          color: #6c757d;
          padding: 0 0.5rem;
        }

        .breadcrumb-item.active {
          color: #343a40;
        }
      `}</style>
    </nav>
  );
}

export default BreadcrumbNav;
